import React from 'react'

import Icon, { type IconName } from '@/components/icon'

type EmptyStateProps = Readonly<{
	iconName?: IconName
	title: string
	description?: string
	hint?: string
}>

export default function EmptyState({
	iconName,
	title,
	description,
	hint,
}: EmptyStateProps) {
	return (
		<div className="flex flex-col w-full h-full items-center py-4 gap-2 border-2 border-dashed border-gray-300 bg-gray-50 dark:bg-transparent rounded-lg mt-3">
			{iconName && (
				<Icon
					name={iconName}
					size={48}
					sx={{
						color: 'grey.400',
					}}
				/>
			)}
			<p className="text-xl font-semibold">{title}</p>
			{description && (
				<p className="text-sm text-gray-600 dark:text-gray-200">
					{description}
				</p>
			)}
			{hint && (
				<p className="text-xs text-gray-600 dark:text-gray-200 italic">
					{hint}
				</p>
			)}
		</div>
	)
}
